import {useNavigate} from 'react-router-dom'
import {TermEditor} from './TermEditor'

export const ContractTermForm = ({formik, loading = false}) => {
  const navigate = useNavigate()

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-2 col-form-label fw-bold fs-6'>
              <span className='required'>Nome</span>
            </label>
            <div className='col-lg-10 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Ex.: termo_acnelux'
                {...formik.getFieldProps('name')}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors?.name}</div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-2 col-form-label fw-bold fs-6'>
              <span className='required'>Descrição</span>
            </label>
            <div className='col-lg-10 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Ex.: Documento termo utilizado no tratamento com Acne Lux'
                {...formik.getFieldProps('description')}
              />
              {formik.touched.description && formik.errors.description && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors?.description}</div>
                </div>
              )}
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-2 col-form-label fw-bold fs-6'>
              <span className='required'>Conteúdo</span>
            </label>
            <div className='col-lg-10 fv-row'>
              <TermEditor
                value={formik.values.content}
                onChange={(html) => formik.setFieldValue('content', html)}
                onBlur={() => formik.setFieldTouched('content', true)}
              />
              <div className='form-text'>
                O bloco de assinatura (cidade, data, cliente, responsável e testemunha) é adicionado
                automaticamente ao final do termo no PDF.
              </div>
              {formik.touched.content && formik.errors.content && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors?.content}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='reset' className='btn btn-secondary me-2' onClick={() => navigate(-1)}>
            Cancelar
          </button>
          <button type='submit' className='btn btn-danger' disabled={loading || !formik.isValid}>
            {!loading && 'Salvar'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Salvando...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </form>
  )
}
